import {clarityService} from './services/clarity/clarityService';

/**
 * Initialize Microsoft Clarity
 * 
 * This function should be called at the module level in App.tsx
 * alongside other analytics initialization (similar to InitSentry, InitSegment)
 * 
 * Environment Variables Required:
 * - REACT_APP_CLARITY_PROJECT_ID: Your Microsoft Clarity project ID
 */
export const InitClarity = (): void => {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

  if (!projectId) {
    console.warn(
      'Microsoft Clarity not initialized: REACT_APP_CLARITY_PROJECT_ID environment variable is missing'
    );
    return;
  }

  if (process.env.NODE_ENV === 'development') {
    console.log('Initializing Microsoft Clarity in development mode', { projectId });
  }

  try {
    clarityService.init(projectId);
  } catch (error) {
    console.error('Failed to initialize Microsoft Clarity:', error);
  }
};

export default InitClarity; 